import React, { Component, Fragment } from 'react';
import { func, string, bool, array} from 'prop-types';
import { connect } from 'react-redux';
import classnames from 'classnames';

import Footer from 'components/Footer/Footer';
import TopBanner from '@components/TopBanner/TopBanner';

const mapStateToProps = ({ viewMode }) => ({
  isDarkMode: viewMode.isDarkMode,
});

class MainContent extends Component {
  static propTypes = {
    component : func.isRequired,
    subtitle  : string,
    title     : string,
    tabs      : array,
    isDarkMode: bool,
  };

  render() {
    const { component, title, subtitle, isDarkMode, tabs } = this.props;

    const hasTopBanner = tabs || subtitle;

    const mainContentClass = classnames(
      'stage',
      `${title}-page`,
      {
        darkMode: isDarkMode,
        'no-top-banner': !hasTopBanner
      },
    );

    return (
      <Fragment>
        {hasTopBanner && <TopBanner title={title} subtitle={subtitle} tabs={tabs} />}

        <div className={mainContentClass}>
          {component()}
        </div>

        <div className="footer-wrapper main-content">
          <Footer supportLink={'/support'}/>
        </div>
      </Fragment>
    );
  }
}

export default connect(mapStateToProps)(MainContent);



// WEBPACK FOOTER //
// ./src/components/MainContent.js